/**
 * Stripe price ID for MSE Pro plan.
 * Replace with real price ID when integrating with Stripe.
 */
export const STAGE_MSE_PRO_MONTHLY = 'price_1T9i1Q4BHjfY2tkoYsZBydxB';
export const STAGE_MSE_PRO_YEARLY = 'price_1T9i1r4BHjfY2tkoFpaBtbIk';
export const US_MSE_PRO_MONTHLY = 'price_1T9hlw3n4XHnBaSmV54ChgKh';
export const US_MSE_PRO_YEARLY = 'price_1T9hmv3n4XHnBaSmZpvpwwdS';
export const EU_MSE_PRO_MONTHLY = 'price_1T9i3o3n4XHnBaSmf6VRH8nY';
export const EU_MSE_PRO_YEARLY = 'price_1T9i433n4XHnBaSmLnlDej1x';
